export default {
    apot: {
        title: 'Listen to Forever Young on the following platforms',
    },
    cookie: {
        text: 'Wir nutzen Cookies & Google Analytics um dir die bestmögliche Browsing-Erfahrung zu bieten. Die mit Hilfe von Cookies & Google Analytics gesammelten Daten werden zur Optimierung unserer Webseite genutzt.',
    },
};
